var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEllipseMediumScore = props => {
  const _uid = React.useId().replace(/:/g, '');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none",
    viewBox: "0 0 10 10"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#" + _uid + "ellipse-medium-score_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8E4B10",
    d: "M1 6.667a.7.7 0 0 0-.471.177.58.58 0 0 0-.196.429V9.09c0 .16.07.315.196.428A.7.7 0 0 0 1 9.697a.7.7 0 0 0 .472-.178.58.58 0 0 0 .195-.428V7.273a.58.58 0 0 0-.195-.429A.7.7 0 0 0 1 6.667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFEBAD",
    d: "M8.529.178A.7.7 0 0 1 9 0c.177 0 .347.064.472.178a.58.58 0 0 1 .195.428v8.485a.58.58 0 0 1-.195.428.7.7 0 0 1-.472.178.7.7 0 0 1-.471-.178.58.58 0 0 1-.195-.428V.606c0-.16.07-.315.195-.428M5.862 2.602a.7.7 0 0 1 .471-.178c.177 0 .347.064.472.178A.58.58 0 0 1 7 3.03v6.06a.58.58 0 0 1-.195.43.7.7 0 0 1-.472.177.7.7 0 0 1-.471-.178.58.58 0 0 1-.195-.428V3.03c0-.161.07-.316.195-.43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8E4B10",
    d: "M3.195 5.026a.7.7 0 0 1 .472-.178c.176 0 .346.064.471.178a.58.58 0 0 1 .195.429V9.09a.58.58 0 0 1-.195.428.7.7 0 0 1-.471.178.7.7 0 0 1-.472-.178A.58.58 0 0 1 3 9.091V5.455c0-.161.07-.315.195-.429"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _uid + "ellipse-medium-score_svg__a"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h10v10H0z"
  })))));
};
export { SvgEllipseMediumScore as ReactComponent };
export default __webpack_public_path__ + "c286b2985ee79fdf16d3ca678271616c.svg";